// <Icon type="file-image" />
import React from 'react';
import ImagePlayer from 'common/components/ImagePlayer';

interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  return (
    <View wp={10} className="wsui-frame-wrapper">
      <ImagePlayer imgSrc={model.resourceUrl} />
    </View>
  );
};
